<template>
  <v-card  
        class="py-2 px-3 mx-1 my-1 grey lighten-2" 
        height="100%" 
        text-color="grey darken-4"
        style="border-radius: 2px;"
        flat
        :to="{ name: 'Innung', params: { slug: innung.slug }}">
    <v-layout column>
      <v-layout row> 
      <v-flex xs5 class="py-1 px-0 text-xs-center">
        <v-avatar size="80" tile>
          <v-img
            v-if="innung.logo"
            :src="innung.logo"
            max-height="100px"
            contain
          ></v-img>
        </v-avatar>
      </v-flex>
       <v-flex xs7>
        <div class="fill-height mt-0 py-2">
          <div class="subheading ml-2">{{ innung.name }}</div>
        </div>
      </v-flex>
      </v-layout>
    </v-layout>
  </v-card>
</template>

<script>

export default {
  props: ['innung'],
  components: {},
  data () {
    return {

    }
  },
  computed: {
  },
  mounted: function () {},
  methods: {}
}
</script>

<style></style>
